import { CatalogVariantFragmentFragment } from '@notino/shared/definitions/types';

export const isPriceSame = (
  variants: CatalogVariantFragmentFragment[]
): boolean =>
  variants.every(
    (variant, _, array) => variant.price.value === array[0].price.value
  );
